import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App';
export function AppRouter() {
  return <BrowserRouter data-id="element-30">
      <App data-id="element-31" />
    </BrowserRouter>;
}